import { Chip, ElementsGroup } from '@otp/ui';
import { StoreModel } from 'src/graphql/generated/graphql';

export const StoresField = ({ stores }: { stores: Partial<StoreModel>[] }) => (
  <ElementsGroup
    elements={stores.map((store) => (
      <Chip key={store.id} label={`#${store.nationalStoreNumber}`} />
    ))}
    limit={2}
  />
);
